export const SETUP_CONFIGURATION_STEP = 'SETUP_CONFIGURATION_STEP';
export const SELECT_PRODUCTS_STEP = 'SELECT_PRODUCTS_STEP';
export const DEFINE_SHIPMENTS_STEP = 'DEFINE_SHIPMENTS_STEP';
export const ORDERED_ASN_STEPS = [SETUP_CONFIGURATION_STEP, SELECT_PRODUCTS_STEP, DEFINE_SHIPMENTS_STEP];

// setup configuration
export const RECEIVING_CENTER = 'receivingCenter';
export const PACKAGE_TYPE = 'packageType';
export const PURCHASE_ORDER_NUMBER = 'purchaseOrderNumber';
export const SHIPPING_OPTIONS = {
  parcel: 'Parcel',
  palletizedContainer: 'Pallet',
  floorLoadedContainer: 'FloorLoadedContainer',
};

// TODO: remove fake data for development
export const FAKE_WAREHOUSE_DATA = [
  {
    id: '8',
    name: 'Cicero (IL)',
    timezone: 'Central Standard Time',
    address1: '5900 W OGDEN AVE',
    address2: '',
    city: 'Cicero',
    state: 'IL',
    country: 'US',
    zip_code: '60804',
    phone_number: '8444744726',
    email: 'support@shipbob.com',
  },
  {
    id: '10',
    name: 'Moreno Valley (CA)',
    timezone: 'Pacific Standard Time',
    address1: '28010 Eucalyptus Ave',
    address2: 'Building #1',
    city: 'Moreno Valley',
    state: 'CA',
    country: 'US',
    zip_code: '92555',
    phone_number: '8444744726',
    email: 'support@shipbob.com',
  },
];

// select products
export const DEFAULT_PRODUCT_QUANTITY = 1;
export const SELECTED_PRODUCTS = 'selectedProducts';
export const HAS_CONFIRMED_DANGEROUS_GOODS = 'hasConfirmedDangerousGoods';

// define shipments
export const BOXES = 'boxes';
export const DEFAULT_BOXES_PER_CONFIG = 1;

// schedule freight
export const CARRIER_CONTACT = 'carrierContact';
export const TENANT_CONTACT = 'tenantContact';
export const DELIVERY_NOTE = 'deliveryNote';
export const DROP_OFF_OPTION_ONE = 'dropOffOption1';
export const DROP_OFF_OPTION_TWO = 'dropOffOption2';
export const DROP_OFF_OPTION_THREE = 'dropOffOption3';
export const CONFIRMED_DROP_OFF_DATE = 'confirmedDropOffDate';
